export default __webpack_public_path__ + "static/media/c_4.353055bf.svg";